import React from 'react';
import { Paper } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const TableUser = (props) => (
    <Paper className="new-question">
        <div>
            
                {props.users.length > 0 ? (
                    props.users.map((user) => (
                        <div key={user.questionId}>
                            <div className="question-container">
                                <div className="question-title">
                                    {user.questionText}
                                    <span>{user.isAttachmentRequired === true ? 'Attachment Required' : 'Attachment Not Required'}</span>
                                </div>
                                
                                <div className="question-action">
                                    <FontAwesomeIcon icon={faPen} size="2x" onClick={() => props.editRow(user)}/>
                                     <FontAwesomeIcon icon={faTrashAlt} size="2x" onClick={() => props.deleteUser(user.questionId)} />
                                    
                                </div>
                                <div className="clear" />
                            </div>
                            
                        </div>                        
                    ))
                ) : (
                    <div>
                        No Questions
                    </div>
                )}
            
        </div>
    </Paper>
);

export default TableUser;
